import axios from 'axios';
import { URL_TOKEN } from '../constants/endpoints';

const tokenService = axios.create({
    baseURL: URL_TOKEN,
    headers: {
        'Content-Type': 'application/json',
        Apikey: process.env.API_KEY_TOKENIZER,
    },
});

export const getToken = async () => {
    try {
        const res = await tokenService.post('', {
            action: 'getJWT',
        });
        return res.data.data.id_token;
    } catch (error) {
        console.error(error);
    }
};
